import { Autocomplete, Button, alpha, styled } from '@mui/material';

export const StyledSearchOption = styled(Button)(({ theme }) => ({
  marginLeft: '12px',
  marginTop: '6px',
  marginBottom: '6px',
  cursor: 'pointer',
  color: theme.palette.text.primary,
  fontSize: '13px',
  wordBreak: 'break-word',
}));

export const StyledGroupHeader = styled('div')(({ theme }) => ({
  padding: '8px 12px',
  backgroundColor: alpha(theme.palette.text.primary, 0.04),
  fontWeight: 600,
  fontSize: '13px',
  color: theme.palette.text.secondary,
  '& .child-module': {
    display: 'block',
    marginLeft: '12px',
    fontWeight: 500,
    fontSize: '12px',
    color: theme.palette.text.secondary,
    marginTop: '2px',
  },
}));

export const NoOptionsBox = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
  padding: '24px 16px',
  color: theme.palette.text.secondary,
  fontSize: '13px',
  '& .MuiSvgIcon-root': {
    fontSize: '28px',
    opacity: 0.4,
  },
}));

export const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: alpha(theme.palette.text.primary, 0.04),
    borderRadius: '14px',
    border: `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
    transition: 'border-color 120ms ease, background-color 120ms ease',
    '& fieldset': {
      border: 'none',
    },
    '&:hover': {
      backgroundColor: alpha(theme.palette.text.primary, 0.06),
      borderColor: alpha(theme.palette.text.primary, 0.12),
    },
    '&.Mui-focused': {
      backgroundColor: theme.palette.background.paper,
      borderColor: theme.palette.primary.main,
    },
  },
  '& .MuiOutlinedInput-input': {
    padding: '6px 10px',
    fontSize: '13px',
  },
  '& .MuiAutocomplete-listbox': {
    padding: '4px',
  },
  '& .MuiAutocomplete-paper': {
    borderRadius: '14px',
    border: `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
    marginTop: '8px',
  },
})) as typeof Autocomplete;
